import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/SimplePage.css';
import useSafeBack from '../hooks/useSafeBack';

function PastHires() {
  const navigate = useNavigate();
  const safeBack = useSafeBack('/hirer/dashboard');

  return (
    <div className="sa-page">
      <div className="sa-container">
        <div className="simple-page__header">
          <button className="simple-page__back" onClick={safeBack} aria-label="Go back">
            ←
          </button>
          <div>
            <h1 className="simple-page__title">Past Hires</h1>
            <p className="simple-page__subtitle">Your previous requests and completed jobs.</p>
          </div>
        </div>

        <div className="sa-card simple-page__card">
          <div className="simple-page__empty">
            No past hires yet. When you contact a technician, they’ll show up here.
          </div>
          <button className="sa-btn sa-btn--primary" onClick={() => navigate('/hirer/dashboard')}>
            Find technicians
          </button>
        </div>
      </div>
    </div>
  );
}

export default PastHires;

